import axios from '@/axios.js';
//import store from '@/store'
//import moment from 'moment'

//const cancelTokenSource = axios.CancelToken.source();
//const controller = new AbortController();
// const signal = controller.signal

const actions = {


  loginFromAccessToken({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/users/details", item)
        .then((response) => {
          const token = item['accessToken'];//response.data.result.data.accessToken
          const userRole = response.data.result.roleId;
          const user = response.data.result;
          localStorage.setItem('userRole', userRole)
          // localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('loginuserRole', userRole)
          // localStorage.setItem('loginToken', token)
          localStorage.setItem('loginUserData', JSON.stringify(user))
          localStorage.setItem('logintenantId', '')
          axios.defaults.headers.common['Authorization'] = token
          commit('auth_success', { accessToken: token, user: user, role_id: userRole })
          resolve(response)
        })
        .catch((error) => {
          console.log(error);
          reject(error.response.data.result)
        })
    })
  },



  login({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/auth/login", item)
        .then((response) => {
          const token = response.data.result.data.accessToken;

          let postData = { 'accessToken': '' };
          postData['accessToken'] = token;
          localStorage.setItem('role_id', response.data.result.data.roleId)
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(response.data.result.data))
          localStorage.setItem('colombohurdLaw', response?.data?.result?.data?.colombohurdLaw ? response.data.result.data.colombohurdLaw : false)
          localStorage.setItem('greencardInc', response?.data?.result?.data?.greencardInc ? response.data.result.data.greencardInc : false)
          localStorage.setItem('oscarsGreenCard', response?.data?.result?.data?.oscarsGreenCard ? response.data.result.data.oscarsGreenCard : false)
          axios.defaults.headers.common['Authorization'] = token
          const user = response.data.result.data;
          commit('auth_success', user)
          resolve(response.data.result.data)
        })
        .catch((error) => {
          reject(error.response.data);
        }
        )
    })
  },


  logout({ commit }) {
    return new Promise((resolve) => {
      console.log(commit);
      commit('logout')
      localStorage.removeItem('token');
      localStorage.removeItem('role_id');
      localStorage.removeItem('user');
      localStorage.removeItem('colombohurdLaw');
      localStorage.removeItem('greencardInc');
      localStorage.removeItem('oscarsGreenCard');
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },

  getList({ commit }, { data, path = " " }) {
    return new Promise((resolve, reject) => {
      axios.post(path, data)
        .then((response) => {
          console.log(response)
          resolve(response.data.result)
        })
        .catch((error) => {

          reject(error);

        })
    })
  },

  commonAction({ commit }, { data, path = "" }) {
    return new Promise((resolve, reject) => {
      axios.post(path, data)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          // alert(JSON.stringify(error.response.data.result));
          // alert(error.response.data.message);
          reject(error.response.data);

        })
    })
  },
  uploadS3File({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("/s3/upload", postdata)
        .then((response) => {
          console.log(response);
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result.message);
          }
        })
    })
  },


  getcountries() {
    return new Promise((resolve) => {
      let item = {
        page: 1,
        perpage: 1000,
        category: "countries",
        //tenantId: "5db7d79d6032453bd060ed9c",
      };
      //if (tenantId) {
      //item = Object.assign(item, { "tenantId": tenantId })
      //  }
      axios.post("/masterdata/list", item)
        .then((response) => {
          resolve(response.data.result.list)
        });
    })
  },
  getstates({ commit }, countryId) {
    return new Promise((resolve) => {
      let item = {
        matcher: {
          countryId: countryId
        },
        page: 1,
        perpage: 1000,
        category: "states",
        //tenantId: "5db7d79d6032453bd060ed9c",
      };

      // if (tenantId) {
      //   item = Object.assign(item, { "tenantId": tenantId })
      // }
      axios.post("/masterdata/list", item)
        .then((response) => {
          //  commit('getcountries')
          resolve(response.data.result.list)
        });
    })
  },
  getlocations({ commit }, obj) {
    return new Promise((resolve) => {
      let item = {
        matcher: {
          stateId: obj.stateId
        },
        page: 1,
        perpage: 1000,
        category: "locations",
        //tenantId: "5db7d79d6032453bd060ed9c",
      };
      // if (tenantId) {
      //   item = Object.assign(item, { "tenantId": tenantId })
      // }
      axios.post("/masterdata/list", item)
        .then((response) => {
          //  commit('getlocations')
          resolve(response.data.result.list)
        });
    })
  },
  addLocations({ commit }, obj) {
    return new Promise((resolve) => {
      let item = {
        page: 1,
        perpage: 1000,
        stateId: obj.stateId,
        name: obj.name,
        category: "locations",
        // tenantId: "5db7d79d6032453bd060ed9c",
      };

      // if (tenantId) {
      // item = Object.assign(item, { "tenantId": tenantId })
      // }
      axios.post("/masterdata/add", item)
        .then((response) => {
          resolve(response.data.result)
        });
    })
  },
  getMasterData({ commit }, category = '') {
    return new Promise((resolve) => {
      let item = {
        matcher: {
        },
        page: 1,
        perpage: 1000,
        category: category//"user_departments","customer_types","user_roles"
      };
      axios.post("/masterdata/list", item)
        .then((response) => {
          //  commit('getlocations')
          resolve(response.data.result.list)
        });
    })
  },
  getBillingType({ commit }, category = 'user_departments') {
    return new Promise((resolve) => {
      let item = {
        matcher: {
        },
        page: 1,
        perpage: 1000,
        category: category//"user_departments",
      };
      axios.post("/masterdata/list", item)
        .then((response) => {
          //  commit('getlocations')
          resolve(response.data.result.list)
        });
    })
  },
  getDepartments({ commit }) {
    return new Promise((resolve) => {
      let item = {
        matcher: {
        },
        page: 1,
        perpage: 1000,
        category: "user_departments",
      };
      axios.post("/masterdata/list", item)
        .then((response) => {
          //  commit('getlocations')
          resolve(response.data.result.list)
        });
    })
  },
  
  addMasterData({ commit }, obj) {
    return new Promise((resolve) => {
      let item = {
        page: 1,
        perpage: 1000,
        name: obj.name,
        category: obj.category,
      };

      axios.post("/masterdata/add", item)
        .then((response) => {
          resolve(response.data.result)
        });
    })
  },
  userregister({ commit }, postdata) {

    // if(tenantId){
    //   postdata = Object.assign( postdata ,{"tenantId":tenantId})
    // }
    return new Promise((resolve, reject) => {
      axios.post("/users/register", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  userUpdate({ commit }, postdata) {

    // if(tenantId){
    //   postdata = Object.assign( postdata ,{"tenantId":tenantId})
    // }
    return new Promise((resolve, reject) => {
      axios.post("/users/update", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getUsersList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/users/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },


  getUserDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/users/details", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getProfDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/professor/details", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  createCustomer({ commit }, postdata) {

    // if(tenantId){
    //   postdata = Object.assign( postdata ,{"tenantId":tenantId})
    // }
    return new Promise((resolve, reject) => {
      axios.post("/customer/create", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updateCustomer({ commit }, postdata) {

    // if(tenantId){
    //   postdata = Object.assign( postdata ,{"tenantId":tenantId})
    // }
    return new Promise((resolve, reject) => {
      axios.post("/customer/update", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getcustomerList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/customer/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getCustomerDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/customer/details", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getEvaluationsList({ commit }, { postdata, cancelTokenSource }) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/list", postdata, { signal: cancelTokenSource })
        //   axios.post("/evaluation/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {

          if (error && error.response && error.response.data) {
            reject(error.response.data.message);
          } else if (error && error.message) {
            reject(error.message);
          } else {
            reject('error');
          }
        })
    })
  },

  getIndividualEvaluationsList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {

          if (error && error.response && error.response.data) {
            reject(error.response.data.message);
          } else if (error && error.message) {
            reject(error.message);
          } else {
            reject('error');
          }
        })
    })
  },


  addEmailTemplate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/email-template/create", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updateEmailTemplate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/email-template/update", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getEmailsList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/email-template/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  createEvaluation({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/create", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);
        })
    })
  },

  addEvaluationTemplate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation-template/create", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updateEvaluationTemplate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation-template/update", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getEvaluationTemplatesList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation-template/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  
  getRepositoryList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/repository-template/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getSignedUrl({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("s3/get-signed-url", postdata)
        .then((response) => {
          console.log(response);
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },
  pdftoword({ commit }, postdata) {
    return new Promise((resolve) => {
      axios.post("convert/pdf-to-word", postdata, {
        responseType: 'blob', 
      }).then((response) => {
          console.log(response);
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            resolve(error.response.data.result);
          }
        })
    })
  },
  getEvaluationDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/details", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  mapClientToEvaluation({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/add-customer", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  assignUser({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/assign-user", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data);

        })
    })
  },

  assignEvaluator({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/assign-evaluator", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },



  submitEvaluationReview({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/review-activity", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
            reject(error.response.data);
        })
    })
  },
  requestPayment({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/make-payment-request", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data);
        })
    })
  },

  createInvoice({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/create", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  saveInvoice({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/save", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  setEvaluationDueDate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/add-dueDate", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  assignEvaluationTemplate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/assign-template", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  submitToProfessor({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/request-for-professor-sign", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data);
        })
    })
  },
  uploadEvaluationDocuments({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/add-documents", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  uploadRevisedDocuments({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/upload-revised-documents", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  evaluationDeliveryToClient({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/delivery", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data);

        })
    })
  },
  evaluationCancel({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/cancel-evaluation", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updatePayment({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/update-payment-details", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },


  getInvoicesList({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getInvoiceDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/details", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getInvoiceStats({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/invoice-stats-list", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  sendInvoiceRemainders({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/reminder", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  downloadInvoiceFile({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/invoice/download-invoice", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getStatsCount({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/dashboard/stats-count", postdata)
        .then((response) => {
          resolve(response.data)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getTopFiveEvaluations({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/dashboard/top-five-evaluations", postdata)
        .then((response) => {
          resolve(response.data)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getEvaluationsstats({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/dashboard/evaluation-stats", postdata)
        .then((response) => {
          resolve(response.data)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  showMostHandledCases({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/dashboard/most-cases-handled", postdata)
        .then((response) => {
          resolve(response.data)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getStatsChartView({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/dashboard/stats-chart-view", postdata)
        .then((response) => {
          resolve(response.data)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  evaluationReviewConfirm({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/review-confirmed", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data);
        })
    })
  },
  forgot_password({ commit }, item) {
    return new Promise((resolve) => {
      axios.post("/auth/forgot-password", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { resolve(error.response) })
    })
  },
  updatePassword({ commit }, item) {

    return new Promise((resolve) => {
      axios.post("/auth/update-password", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { resolve(error.response) })
    })
  },
  updateEvaluationDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/update", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
 workingoneval({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/workingon", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  createEvaluationNote({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/create-note", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updateEvaluationNote({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/update-note", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  sendEvaluationEmail({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/send-email", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data);

        })
    })
  },

  uploadEvaluationSupportedDocuments({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/support-documents", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  getFilteredStatsChartView({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/dashboard/stats-chart", postdata)
        .then((response) => {
          resolve(response.data)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  getInboxEmails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/mail-inbox/list", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getNewStatus({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/make-payment-request-change", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  getEmailDetails({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/mail-inbox/details", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

  getDueTodayEvaluations({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("dashboard/due-today", postdata)
        .then((response) => {
          resolve(response)

        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  paymentStatusBulkUpdate({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/update-payment-status", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  signupCustomer({ commit }, postdata) {

    // if(tenantId){
    //   postdata = Object.assign( postdata ,{"tenantId":tenantId})
    // }
    return new Promise((resolve, reject) => {
      axios.post("/auth/signup", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  createTemplateFolder({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation-template/folder-create", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  cancelBulkRequests({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/cancel-evaluation", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  removeEvaluator({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/delete-assign-user", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  downloadAllFiles({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/s3/get-zipped-files", postdata, {
        responseType: 'blob',
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          if(error&&error.response&&error.response.data&&error.response.data.message){
            reject(error.response.data.message);
          }else{
            reject('Something went wrong. Please try again after sometime');
          }

        })
    })
  },
  deleteFolderOrDocument({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation-template/delete", postdata)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updateTemplateFolder({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation-template/update", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },  
  evalNameEmailExists({ commit }, postData) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/check-exist-eval", postData)
        .then(response => {
          resolve(response.data.result)
        })
        .catch(error => {
          reject(error.response.data.message)
        })
    })
  },
  resendEmail({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/resend-email", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
            reject(error.response.data);
        })
    })
  },
  downloadExistingAllFiles({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/s3/get-zipped-files", postdata)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },
  updateEvaluationInvoiceId({ commit }, postdata) {
    return new Promise((resolve, reject) => {
      axios.post("/evaluation/update-invoice", postdata)
        .then((response) => {
          resolve(response.data.result)
        })
        .catch((error) => {
          reject(error.response.data.message);

        })
    })
  },

}

export default actions;
